import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../services/LanguageContextProvider';
import { useConsent } from '../../services/ConsentContextProvider';
import { localizedPath } from '../../i18n/locales';
import { E2DAttribution } from './E2DAttribution';
import e2dLogo from '../../assets/images/e2d-logo.webp';
import '../../css/visualComponent/SiteFooter.css';

export const SiteFooter = () => {
  const { t } = useTranslation('global');
  const { language } = useLanguage();
  const { reopen } = useConsent();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-legal">
          <span className="site-footer-copy">© {year} Åby Foods Oy Ab Ltd</span>
          <Link className="site-footer-link" to={localizedPath(language, 'cookies')}>
            {t('cookies.policy.title')}
          </Link>
          <button type="button" className="site-footer-link site-footer-btn" onClick={reopen}>
            {t('cookies.banner.title')}
          </button>
        </div>
        <div className="site-footer-attr">
          <E2DAttribution logoSrc={e2dLogo} />
        </div>
      </div>
    </footer>
  );
};
